import React from 'react'
import './DashboardPeriodSelector.scss';
import {Action, TimePeriodSelector } from 'botbit-ui-components';
import { Button } from 'react-bootstrap';
import translate from "../../../config/translations/translate";

const DashboardPeriodSelector = ({timePeriodOptions, selectedPeriod, handlePeriodChange, readOnly = false, setSelectedPeriod, t, useDisabledDays = true}) => {

  const [currentValue, setCurrentValue] = React.useState(selectedPeriod);
  // Función para cerrar el dropdown
  const closeDropdown = () => {

    const dropdownToggles = document.querySelectorAll('.botbit-dropdown-trigger');
    dropdownToggles.forEach(dropdownToggle => {
      if (dropdownToggle && dropdownToggle.getAttribute('aria-expanded') === 'true') {
        dropdownToggle.click();
      }
    });
  };

  

  const ActionContent = (selectedValue) => {
    
    // Mapeo de timePeriodOptions a una lista de labels
    const periodLabels = timePeriodOptions.map(option => option.value);
    periodLabels.push('CUSTOM');

    const today = new Date();
    const disabledDays = [];
    //evitar seleccion de fechas futuras
    for (let i = 0; i < 800; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      // Limpiar la hora para evitar problemas de comparación
      date.setHours(0, 0, 0, 0);
      disabledDays.push(new Date(date));
    }

    if(useDisabledDays){
      // Calcular los últimos 15 días (incluyendo hoy)  
      for (let i = 0; i < 15; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        // Limpiar la hora para evitar problemas de comparación
        date.setHours(0, 0, 0, 0);
        disabledDays.push(new Date(date));
      }
    }

    return (
        <div className='action-content-container'>
            <TimePeriodSelector
                expanded={true}
                options={periodLabels}
                value={currentValue}
                label={t('timePeriod.label')}
                placeholder={t('timePeriod.placeholder')}
                renderMode="header"
                getValue={(selectedValue) => {
                    // Manejar la selección
                    setCurrentValue(selectedValue);
                }}
                labels={{
                    from: t('fromLabel'),
                    to: t('toLabel'),
                    dateRange: t('dateRangeLabel'),
                    customRange: t('customRangeLabel')
                }}
                disabledDays={disabledDays}
            />
            <Button className='apply-button' onClick={() => {
              handlePeriodChange(currentValue);              
              closeDropdown();
            }}>
                <span>
                    {t('apply')}
                </span>
            </Button>
        </div>
    )
  }

  if(readOnly){
    return (
      <div className="period-selector">
        <div className="period-selector-label-container">
          <label className="period-selector-label">{t('timePeriod.label')}</label>
          <p>{t(`timePeriod.options.${selectedPeriod.value}`)}</p>
        </div>
      </div>
    )
  }

  
  return (
    <>  
    <div className="period-selector">
      <div className="period-selector-label-container">
        <label className="period-selector-label">{t('timePeriod.label')}</label>
        <Action 
          label={selectedPeriod 
            ? t(`timePeriod.options.${selectedPeriod.value || selectedPeriod}`)
                        : t('timePeriod.placeholder')}
                      renderMode={"DROPDOWN"}
          content={() => ActionContent(selectedPeriod)}
        />   
      </div>
    </div>
    </>
  )
}
DashboardPeriodSelector.translations = {
  fromLabel: {'es': 'Fecha inicial', 'en': 'From date'},
  toLabel: {'es': 'Fecha final', 'en': 'To date'},
  dateRangeLabel: {'es': 'Rango de fechas', 'en': 'Date range'},
  customRangeLabel: {'es': 'Personalizar', 'en': 'Customize'},
  apply: {'es': 'Aplicar', 'en': 'Apply'},
  timePeriod:{
    label: {'es': 'Período', 'en': 'Period'},
    placeholder: {'es': 'Elige un período', 'en': 'Select a period'},
    options: {
      TODAY: {'es': 'Hoy', 'en': 'Today'},
      YESTERDAY: {'es': 'Ayer', 'en': 'Yesterday'},
      LAST_24_HOURS: {'es': 'Últimas 24 horas', 'en': 'Last 24 hours'},
      LAST_7_DAYS: {'es': 'Últimos 7 días', 'en': 'Last 7 days'},
      LAST_15_DAYS: {'es': 'Últimos 15 días', 'en': 'Last 15 days'},
      LAST_30_DAYS: {'es': 'Últimos 30 días', 'en': 'Last 30 days'},
      PAST_MONTH: {'es': 'Mes pasado', 'en': 'Past Month'},
      THIS_MONTH: {'es': 'Este mes', 'en': 'This month'},
      LAST_3_MONTHS: {'es': 'Últimos 3 meses', 'en': 'Last 3 months'},
      LAST_6_MONTHS: {'es': 'Últimos 6 meses', 'en': 'Last 6 months'},
      LAST_12_MONTHS: {'es': 'Últimos 12 meses', 'en': 'Last 12 months'},
      THIS_YEAR: {'es': 'Este año', 'en': 'This year'},
      CUSTOM: {'es': 'Personalizado', 'en': 'Custom'}
    }
  }
}

export default translate(DashboardPeriodSelector);

